"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactQuery = require("react-query");
var _reactI18next = require("react-i18next");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _pickers = require("@material-ui/pickers");
var _axios = _interopRequireDefault(require("axios"));
var _moment = _interopRequireDefault(require("moment"));
var _elementHeadline = _interopRequireDefault(require("../element-headline"));
var _filterButtonGroup = _interopRequireDefault(require("../filter-button-group"));
var _searchField = _interopRequireDefault(require("../search-field"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  divider: {
    position: "relative",
    textAlign: "center",
    "&::before": {
      background: theme.palette.divider,
      content: "''",
      height: 1,
      left: 0,
      marginTop: -2,
      position: "absolute",
      right: 0,
      top: "50%",
      zIndex: theme.zIndex.default
    },
    "& span": {
      background: theme.palette.background.default,
      color: theme.palette.text.divider,
      fontWeight: 700,
      padding: theme.spacing(0, 4),
      position: "relative",
      textTransform: "uppercase",
      zIndex: theme.zIndex.overlay
    }
  },
  periodWrapper: {
    marginTop: theme.spacing(2)
  },
  periodButton: {
    width: "100%"
  },
  inputLabel: {
    marginBottom: theme.spacing(-2)
  }
}));
const ActivityFilter = _ref => {
  var _filter$groups;
  let {
    data,
    onFilter,
    onFilterOpen
  } = _ref;
  const [filter, setFilter] = (0, _react.useState)(data);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const handleConfirm = () => {
    onFilter(filter);
    onFilterOpen(false);
  };
  const handleFilter = values => {
    setFilter({
      ...filter,
      ...values
    });
  };
  const handleReset = () => {
    onFilter({
      from: (0, _moment.default)(),
      to: (0, _moment.default)(),
      groups: [],
      query: ""
    });
    onFilterOpen(false);
  };
  const handleSearch = value => {
    setFilter({
      ...filter,
      query: value
    });
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_searchField.default, {
    directlink: true,
    intentions: true,
    placeholder: t("site.ui.search.placeholders.default"),
    tag: "activities",
    value: filter === null || filter === void 0 ? void 0 : filter.query,
    onChange: handleSearch
  }), /*#__PURE__*/_react.default.createElement(PeriodFilter, {
    from: filter === null || filter === void 0 ? void 0 : filter.from,
    to: filter === null || filter === void 0 ? void 0 : filter.to,
    onChange: handleFilter
  }), /*#__PURE__*/_react.default.createElement(Divider, {
    label: t("site.ui.labels.or")
  }), /*#__PURE__*/_react.default.createElement(DateFilter, {
    from: filter === null || filter === void 0 ? void 0 : filter.from,
    to: filter === null || filter === void 0 ? void 0 : filter.to,
    onChange: handleFilter
  }), /*#__PURE__*/_react.default.createElement(CategoryFilter, {
    groups: (_filter$groups = filter === null || filter === void 0 ? void 0 : filter.groups) !== null && _filter$groups !== void 0 ? _filter$groups : [],
    onChange: handleFilter
  }), /*#__PURE__*/_react.default.createElement(_filterButtonGroup.default, {
    labelConfirm: t("site.ui.buttons.confirm"),
    labelReset: t("site.ui.buttons.reset"),
    onConfirm: handleConfirm,
    onReset: handleReset
  }));
};
const CategoryFilter = props => {
  var _items;
  const {
    groups = [],
    onChange
  } = props;
  const {
    t,
    i18n
  } = (0, _reactI18next.useTranslation)();
  const {
    REACT_APP_PATH
  } = process.env;
  const css = useStyles();
  const url = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListActivityFilter.api?lang=").concat(i18n.language).concat(groups ? "&groups=".concat(groups) : "");
  const {
    data,
    status
  } = (0, _reactQuery.useQuery)(["list-activity-filter", i18n.language], () => _axios.default.get(url));
  let items = [];
  if (status === "success") {
    var _data$data;
    items = data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 || (_data$data = _data$data.groups) === null || _data$data === void 0 ? void 0 : _data$data.items;
  }
  const handleChange = event => {
    let index = groups.findIndex(item => item === parseInt(event.target.value));
    if (index === -1) {
      onChange({
        groups: [...groups, parseInt(event.target.value)]
      });
      return;
    }
    onChange({
      groups: groups.filter(item => item !== parseInt(event.target.value))
    });
  };
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 4
  }, /*#__PURE__*/_react.default.createElement(_elementHeadline.default, {
    title: t("site.ui.headlines.category"),
    component: "h2"
  }), /*#__PURE__*/_react.default.createElement(_core.FormGroup, null, (_items = items) === null || _items === void 0 ? void 0 : _items.map(item => {
    const {
      id,
      title
    } = item;
    return /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
      key: id,
      className: css.inputLabel,
      control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
        checked: groups.includes(id),
        onChange: handleChange,
        value: id
      }),
      label: /*#__PURE__*/_react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: title
        }
      })
    });
  })));
};
const DateFilter = props => {
  const {
    from,
    to,
    onChange
  } = props;
  const css = useStyles();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const handleFromChange = value => {
    onChange({
      from: (0, _moment.default)(value),
      to: (0, _moment.default)(value).add(1, "days")
    });
  };
  const handleToChange = value => {
    onChange({
      from: (0, _moment.default)(from),
      to: (0, _moment.default)(value)
    });
  };
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    mb: 4,
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/_react.default.createElement(_pickers.DatePicker, {
    disablePast: true,
    format: "L",
    fullWidth: true,
    inputVariant: "filled",
    label: t("site.ui.filter.labels.periodFrom"),
    value: from,
    onChange: handleFromChange,
    InputProps: {
      className: css.datepickerInput,
      disableUnderline: true
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/_react.default.createElement(_pickers.DatePicker, {
    disablePast: true,
    format: "L",
    fullWidth: true,
    inputVariant: "filled",
    label: t("site.ui.filter.labels.periodTo"),
    minDate: (0, _moment.default)(from),
    value: to,
    onChange: handleToChange,
    InputProps: {
      className: css.datepickerInput,
      disableUnderline: true
    }
  }))));
};
const Divider = props => {
  const {
    label
  } = props;
  const css = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: css.divider
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "overline",
    component: "span"
  }, label));
};
const PeriodFilter = props => {
  const {
    from,
    to,
    onChange
  } = props;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  const handleClick = (from, to) => {
    onChange({
      from: from,
      to: to
    });
  };
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    mb: 1.5,
    mt: 4
  }, /*#__PURE__*/_react.default.createElement(_elementHeadline.default, {
    title: t("site.ui.headlines.period"),
    component: "h2"
  }), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.periodWrapper,
    container: true,
    spacing: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 4,
    sm: 3
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: css.periodButton,
    color: "primary",
    variant: "".concat(!(0, _moment.default)(from).diff((0, _moment.default)(), "minutes") && !(0, _moment.default)(to).diff((0, _moment.default)(), "minutes") ? "contained" : "outlined"),
    size: "large",
    onClick: () => {
      handleClick((0, _moment.default)(), (0, _moment.default)());
    }
  }, t("site.ui.filter.labels.today"))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 4,
    sm: 3
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: css.periodButton,
    color: "primary",
    variant: "".concat(!(0, _moment.default)(from).diff((0, _moment.default)().add(1, "days"), "minutes") && !(0, _moment.default)(to).diff((0, _moment.default)().add(1, "days"), "minutes") ? "contained" : "outlined"),
    size: "large",
    onClick: () => {
      handleClick((0, _moment.default)().add(1, "days"), (0, _moment.default)().add(1, "days"));
    }
  }, t("site.ui.filter.labels.tomorrow"))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 4,
    sm: 3
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: css.periodButton,
    color: "primary",
    variant: "".concat(!(0, _moment.default)(from).diff((0, _moment.default)(), "minutes") && !(0, _moment.default)(to).diff((0, _moment.default)().add(3, "days"), "minutes") ? "contained" : "outlined"),
    size: "large",
    onClick: () => {
      handleClick((0, _moment.default)(), (0, _moment.default)().add(3, "days"));
    }
  }, t("site.ui.filter.labels.threeDays"))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 3
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: css.periodButton,
    color: "primary",
    variant: "".concat(!(0, _moment.default)(from).diff((0, _moment.default)(), "minutes") && !(0, _moment.default)(to).diff((0, _moment.default)().add(7, "days"), "minutes") ? "contained" : "outlined"),
    size: "large",
    onClick: () => {
      handleClick((0, _moment.default)(), (0, _moment.default)().add(7, "days"));
    }
  }, t("site.ui.filter.labels.sevenDays")))));
};
var _default = exports.default = ActivityFilter;